import { useMutation } from 'react-query';
import { trpc } from '../../../../lib/trpc';

const useUpdateProductDocNameTemplateProperty = () => {
    return useMutation(async (params: { docId: number; name: string; entityId: number }) => {
        return trpc.ProductsApi.updateProductDocumentNameTemplateProperty.mutate(params);
    });
};

export default useUpdateProductDocNameTemplateProperty;
